<template>
  <ChatScriptDownloadBoard :scripts="scripts" @update="updateScript" />
</template>

<script setup lang="ts">
import ChatScriptDownloadBoard from '@/components/domains/chat/script-download/ChatScriptDownloadBoard.vue';
import useChatScripts from '@/composables/domains/chat/useChatScripts';
import { TypeCall } from '@/types/common';

const route = useRoute();

const { scriptSearchForm, scripts, searchScripts, startPolling, stopPolling, updateScript } = useChatScripts();

const initSearchForm = () => {
  scriptSearchForm.value = {
    chatType: (route.query.chatType as TypeCall) ?? 'GENERAL',
    code: (route.query.code as string) ?? '',
    chatId: route.params.chatId as string,
  };
};

const initAuthToken = () => {
  const authToken = route.query.authToken;
  if (authToken) {
    localStorage.setItem('authToken', authToken);
  }
};

onMounted(async () => {
  initAuthToken();
  initSearchForm();
  await searchScripts(true);
  await startPolling();
});

onUnmounted(() => {
  stopPolling();
});
</script>

<style scoped lang="scss"></style>
